<template>
  <div class="carduseMain">
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="cardNo" align="center" label="卡号"> </el-table-column>
      <el-table-column prop="amount" align="center" label="金额"> </el-table-column>
      <el-table-column label="日期" align="center" prop="createTime" min-width="160"> </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { getUseRecods } from "@/api/newApi";
import { formatDate } from "@/utils/formart";
export default {
  name: "",
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      tableData: [
        // {
        //   cardNo: 123456789,
        //   userName: "张三",
        //   amount: 1000,
        //   createTime: "2023-04-26:56:42",
        // },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.getUseRecods();
  },
  methods: {
    getUseRecods() {
      getUseRecods({
        cardNo: this.$route.params.id,
        pageNo: 1,
        pageSize: 10,
      }).then((res) => {
        console.log(res);
        if (res.data.records.length > 0) {
          this.tableData = res.data.records.map((item) => {
            return {
              cardNo: item.cardNo,
              userName: item.userName,
              amount: item.amount,
              createTime: formatDate(item.createTime, "yyyy/MM/dd"),
            };
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.carduseMain {
  padding: 0.2667rem 0.4rem;
  ::v-deep .el-table {
    border-radius: 0.1867rem;
    .el-table__body-wrapper {
      .cell {
        color: #000;
      }
    }
  }
}
</style>
